// Only an explicit manual cancellation allows a fresh upload after a failed attempt.
// The fallback supports a frontend/backend rolling update; it does not grant API rights.
export const cancelledUpload = process => Boolean(process && (process.cancelled === true ||
  process.status === 'failed' && String(process.error_message || '').startsWith('Загрузка явно отменена обмерщиком')));
